<script lang="ts">
    export let isBookings: boolean;
    export let greenText: string;
    export let yellowText: string;
    export let redText: string;
</script>

<div class="legend-container">
    <div>
        <span class="state-pill state-pill-legend good"></span> 
        <span class="legend-desc">{greenText}</span> 
    </div>
    {#if isBookings}
    <div>
        <span class="state-pill state-pill-legend warning"></span> 
        <span class="legend-desc">{yellowText}</span>
    </div>
    {/if}
    <div>
        <span class="state-pill state-pill-legend error"></span> 
        <span class="legend-desc">{redText}</span> 
    </div>
</div>
            
